// Loader.tsx
import React from 'react';
import './Loader.css'; // Make sure to create a CSS file for styles

const Loader: React.FC = () => {
  const loaderUrl = `${window.location.origin}/documents/d/dubai-chamber-intranet/loader?download=true`;

  return (
      <div className="loader-overlay-custom">
          {/* <div className="loader-content">
       <p>Please do not refresh or click any other button.</p>
        <div className="custom-loader"></div>
      </div> */}
          <div
              className="loader-custom"
              style={{ backgroundImage: `url(${loaderUrl})` }}
          ></div>
      </div>
  );
};

export default Loader;
